export default "__VITE_ASSET__BnwQF6uf__"